angular.module('elogbooksDirectives')
    .directive('elbFileDownloadButton', function () {
        return {
            restrict: 'E',
            templateUrl: '/modules/directives/elb-file-download-button/file-download-button.html',
            controller: elbFileDownloadButton,
            replace: true,
            scope: {
                file: '<'
            }
        };

        function elbFileDownloadButton($scope, elbDownloadService) {
            $scope.download = function (file) {
                elbDownloadService.download(file);
            };
        }
    });
